import { render } from "./UangKeluar.vue?vue&type=template&id=c00f3cf8"
import script from "./UangKeluar.vue?vue&type=script&lang=js"
export * from "./UangKeluar.vue?vue&type=script&lang=js"
script.render = render

export default script